import classNames from 'classnames'
import { Tooltip } from 'react-tooltip'

import { commonIcons } from '@apps-common/config/icons'

interface IProps {
  formId?: string
  type?: 'button' | 'submit' | 'div'
  classes?: string
  iconClasses?: string
  disabled?: boolean
  Icon?: any
  callback?: () => void
  tooltip?: {
    id: string
    message: string
    place?: any
    classes?: string
  }
}

export const ButtonRoundArrow: React.FC<IProps> = ({
  formId,
  type = 'button',
  classes,
  iconClasses,
  disabled,
  Icon,
  callback,
  tooltip
}) => {
  const ArrowIcon = commonIcons.arrowAngled

  const component = (
    <>
      {type === 'div' && (
        <div
          className={classNames(
            'min-w-[35px] min-h-[35px] sm:min-w-[37px] sm:min-h-[37px] rounded-full flex items-center justify-center hover:cursor-pointer disabled:opacity-60',
            classes
          )}
          onClick={() => {
            if (callback) {
              callback()
            }
          }}
        >
          {Icon && <Icon className={classNames('text-[1.1rem]', iconClasses)} />}
          {!Icon && <ArrowIcon className={classNames('text-[1.1rem]', iconClasses)} />}
        </div>
      )}
      {(type === 'button' || type === 'submit') && (
        <button
          form={formId}
          type={type}
          className={classNames(
            'min-w-[35px] min-h-[35px] sm:min-w-[37px] sm:min-h-[37px] rounded-full flex items-center justify-center hover:cursor-pointer disabled:opacity-60',
            classes
          )}
          disabled={disabled}
          onClick={() => {
            if (callback) {
              callback()
            }
          }}
        >
          {Icon && <Icon className={classNames('text-[1.1rem]', iconClasses)} />}
          {!Icon && <ArrowIcon className={classNames('text-[1.1rem]', iconClasses)} />}
        </button>
      )}
    </>
  )

  return tooltip && !disabled ? (
    <div data-tooltip-id={tooltip.id} data-tooltip-content={tooltip.message}>
      {component}
      <Tooltip
        id={tooltip.id}
        place={tooltip.place}
        className={classNames('hidden sm:inline-block !bg-surface !text-text border border-border !drop-shadow-sm z-[60]', tooltip.classes)}
      />
    </div>
  ) : (
    component
  )
}
